"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeydown = useKeydown;
const react_1 = require("react");
const use_identity_ref_1 = require("../use-identity-ref");
const on_1 = require("../../helpers/on");
/**
 * Хук, добавляющий обработчик нажатия на клавишу.
 * @param targetKey Клавиша, для которой отслеживается нажатие.
 * @param callback Обработчик нажатия.
 */
function useKeydown(targetKey, callback) {
    const ref = (0, use_identity_ref_1.useIdentityRef)(callback);
    (0, react_1.useEffect)(() => (0, on_1.on)(document, 'keydown', event => {
        const handler = ref.current;
        (event.key === targetKey || event.code === targetKey) && handler?.(event);
    }), [targetKey]);
}
//# sourceMappingURL=index.js.map